/**
 * @fileoverview Confirmação de "Cancelar fluxo inteligente" (faixa da conversa
 * e modal de templates): para os envios automáticos; o atendimento continua.
 * `onCancelled(run)` recebe a abordagem atualizada que a API devolve; sem ela
 * (erro), a tela relê.
 */

import React, { useState } from "react";
import { toast } from "react-toastify";

import ConfirmationModal from "../ConfirmationModal";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import { tr } from "./text";

const CancelRunDialog = ({ runId, open, onClose, onCancelled }) => {
  const [busy, setBusy] = useState(false);

  const confirm = async () => {
    setBusy(true);
    let run = null;
    try {
      const { data } = await api.post(`/smart-approach-runs/${runId}/cancel`);
      run = data?.run || null;
      toast.success(tr("cancel.done"));
    } catch (err) {
      // Pode já ter parado (o cliente respondeu, a conversa foi encerrada): a tela relê.
      toastError(err);
    } finally {
      setBusy(false);
      onClose();
      onCancelled(run);
    }
  };

  return (
    <ConfirmationModal
      title={tr("cancel.title")}
      open={open}
      onClose={() => {
        if (!busy) onClose();
      }}
      onConfirm={confirm}
      confirmLoading={busy}
      confirmLabel={tr("cancel.confirm")}
    >
      {tr("cancel.text")}
    </ConfirmationModal>
  );
};

export default CancelRunDialog;
